import { MapSearchInput } from '../../../shared/utils/queryUtils'

export const repaymentsTableFields: MapSearchInput['path'] = {
    name: ['label', 'sender'],
    number: ['amount']
}
